var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Form, Input, Checkbox } from 'antd';
import { useLogin } from '@src/services/login';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { decryptFromBase64, encryptToBase64 } from '@src/utils';
import { classNames, uuid } from '@src/utils';
import logo from './assets/logo_black.png';
import b1 from './assets/b1.jpg';
import b2 from './assets/b2.jpg';
import b3 from './assets/b3.jpg';
import './login-page.scss';
var token_key = '__portal_wmjy';
var prefixCls = 'login-page';
var className = classNames('page', 'app-background', prefixCls);
SwiperCore.use([Autoplay, Pagination]);
var LoginPage = function () {
    var history = useHistory();
    // swiper 轮播图
    var partnerLogo = [b1, b2, b3];
    // 定义验证码
    var _a = useState(uuid()), captcha = _a[0], setCaptcha = _a[1];
    // 设置验证码展示状态
    var _b = useState(false), showCode = _b[0], setCode = _b[1];
    // 表单元素
    var formRef = useRef(null);
    var passwordRef = useRef(null);
    var captchaRef = useRef(null);
    // 设置请求参数
    var _c = useState(function () {
        var userName = '';
        var password = '';
        var keep = false;
        var token = localStorage.getItem('token-login');
        if (token !== void 0 && token !== '' && token !== null) {
            var result = JSON.parse(decryptFromBase64(token, token_key));
            userName = result.userName;
            password = result.password;
            keep = result.keep;
        }
        return { userName: userName, password: password, keep: keep, code: '' };
    }), initialValues = _c[0], setValues = _c[1];
    var valuesRef = useRef(initialValues);
    valuesRef.current = initialValues;
    // 登录请求
    var _d = useLogin(), isSuccess = _d.isSuccess, response = _d.data, error = _d.error, login = _d.mutateAsync;
    // 表单请求
    var handleOnFinish = function (values) {
        var parameter = __assign(__assign({}, values), { userName: values.userName, password: encryptToBase64(values.password, values.userName), os: 0, deviceModel: 'pc', uuid: captcha });
        login(parameter).then(function (response) {
            sessionStorage.setItem('pwdCheck', "" + response.data.pwdCheck);
        });
    };
    // 表单变化触发
    var handleValuesChange = useCallback(function (_, values) {
        valuesRef.current = values;
        setValues(values);
    }, []);
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    // 监听登录状态
    useEffect(function () {
        /** 登录成功 */
        if (isSuccess === true && response !== void 0 && response.data !== null) {
            var _a = valuesRef.current, userName = _a.userName, password = _a.password, keep = _a.keep;
            // // 设置token
            sessionStorage.setItem('token', "" + response.data.token);
            // 记住密码
            if (keep === true) {
                var token = encryptToBase64(JSON.stringify({ userName: userName, password: password, keep: keep }), token_key);
                localStorage.setItem('token-login', token);
            }
            else {
                localStorage.removeItem('token-login');
            }
            history.replace('/');
        }
        /** 登录三次显示验证码 */
        if (['USER20025', '207009-3'].includes("" + (response === null || response === void 0 ? void 0 : response.code))) {
            setCode(true);
        }
        // 验证码显示状态
        if (showCode === true) {
            setMessage('');
            if (['验证码已失效', '验证码不正确'].includes("" + error)) {
                setCaptcha(uuid());
            }
            if ("" + (response === null || response === void 0 ? void 0 : response.code) === '207009-3') {
                setMessage('用户名密码不正确');
                setCaptcha(uuid());
            }
        }
    }, [response, history, isSuccess, showCode, error, message]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: prefixCls + "_body" },
            React.createElement("div", { className: prefixCls + "_body_slider" },
                React.createElement(Swiper, { slidesPerView: 1, loop: true, autoplay: true, pagination: { clickable: true } }, partnerLogo.map(function (value, index) {
                    return (React.createElement(SwiperSlide, { key: index },
                        React.createElement("img", { className: prefixCls + "_item", src: value })));
                }))),
            React.createElement("div", { className: prefixCls + "_body_static" },
                React.createElement("div", { className: "info-box left_panel" },
                    React.createElement("h2", { className: "heading" }, "\u4E3A\u660E\u529E\u5B66\u7406\u5FF5"),
                    React.createElement("p", { className: "info-text" }, "\u56DE\u5F52\u6559\u80B2\u672C\u771F \u5BF9\u5B69\u5B50\u4E00\u751F\u8D1F\u8D23."),
                    React.createElement("h2", { className: "heading" }, "\u4E3A\u660E\u529E\u5B66\u76EE\u6807"),
                    React.createElement("p", { className: "info-text" }, "\u57F9\u517B\u5177\u6709\u4E2D\u56FD\u7075\u9B42 \u4E16\u754C\u773C\u5149\u7684\u73B0\u4EE3\u4EBA \u8BA9\u5B69\u5B50\u66F4\u597D\u5730\u878D\u5165\u4E16\u754C."))),
            React.createElement("div", { className: prefixCls + "_body_form" },
                React.createElement("div", { className: "content" },
                    React.createElement("div", { className: "logo" },
                        React.createElement("img", { src: logo })),
                    React.createElement("div", { className: "container_screen" },
                        React.createElement("div", { className: "screen" },
                            React.createElement("div", { className: "screen__content" },
                                React.createElement("p", { className: "caption" }, "\u667A\u6167\u4E3A\u660E"),
                                React.createElement(Form, { ref: formRef, name: "login", initialValues: initialValues, onFinish: handleOnFinish, onValuesChange: handleValuesChange, className: "login" },
                                    React.createElement(Form.Item, { name: "userName", validateTrigger: ['onChange', 'onBlur'], rules: [
                                            {
                                                required: true,
                                                message: '请输入用户名',
                                                whitespace: true,
                                                validateTrigger: 'onBlur',
                                            },
                                        ] },
                                        React.createElement(Input, { className: "login__input", placeholder: "\u8BF7\u8F93\u5165\u7528\u6237\u540D", autoComplete: "on", onPressEnter: function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } })),
                                    React.createElement(Form.Item, { name: "password", validateTrigger: ['onChange', 'onBlur'], rules: [
                                            {
                                                required: true,
                                                message: '请输入密码',
                                                whitespace: true,
                                                validateTrigger: 'onBlur',
                                            },
                                        ] },
                                        React.createElement(Input.Password, { ref: passwordRef, className: "login__input", placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801", autoComplete: "on", onPressEnter: function () { var _a; return (_a = captchaRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } })),
                                    showCode ? (React.createElement(Form.Item, { name: "code", className: prefixCls + "_captcha_wrapper", validateTrigger: ['onChange', 'onBlur'], rules: [
                                            {
                                                required: true,
                                                message: '请输入验证码',
                                                whitespace: true,
                                                validateTrigger: 'onBlur',
                                            },
                                        ], extra: React.createElement("div", { className: prefixCls + "_captcha", onClick: function () { return setCaptcha(uuid()); } },
                                            React.createElement("img", { src: __PERSONAL_API__ + "/user/getImage?uuid=" + captcha, alt: "\u767B\u5F55\u6821\u9A8C\u7801", height: 32 })) },
                                        React.createElement(Input, { ref: captchaRef, className: "login__input", placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801", style: { paddingRight: '101px' } }))) : (React.createElement("span", null)),
                                    React.createElement(Form.Item, null,
                                        React.createElement("span", { className: prefixCls + "_message" }, message ? message : error),
                                        React.createElement(Form.Item, { name: "keep", valuePropName: "checked" },
                                            React.createElement(Checkbox, { className: prefixCls + "_checkbox" }, "\u8BB0\u4F4F\u5BC6\u7801"))),
                                    React.createElement(Form.Item, null,
                                        React.createElement("button", { className: "button login__submit" },
                                            React.createElement("span", { className: "button__text" }, "\u767B \u5F55")))),
                                React.createElement("div", { className: "social-login" },
                                    React.createElement(Link, { tabIndex: -1, to: "/password_reset" }, "\u5FD8\u8BB0\u5BC6\u7801"))),
                            React.createElement("div", { className: "screen__background" },
                                React.createElement("span", { className: "screen__background__shape screen__background__shape4" }),
                                React.createElement("span", { className: "screen__background__shape screen__background__shape3" }),
                                React.createElement("span", { className: "screen__background__shape screen__background__shape2" }),
                                React.createElement("span", { className: "screen__background__shape screen__background__shape1" })))),
                    React.createElement("div", { id: "footer" },
                        "2014-",
                        new Date().getFullYear(),
                        " \u00A9copy \u5317\u4EAC\u60E0\u4E30\u5B66\u4FE1\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8"))))));
};
export default React.memo(LoginPage);
